import React, { useEffect, useState, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import { useTheme } from "../ThemeContext";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';

import {
  Card,
  Button,
  Spinner,
  Badge,
  Accordion,
  ProgressBar,
  Alert,
  Container,
  Row,
  Col,
  Stack,
  Form,
  Modal,
} from "react-bootstrap";
import {
  Doughnut,
  Bar,
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { apifetch } from '../services/interceptors';
import { set } from "date-fns";
import { riskBandFor, bandStyleScore } from './report/shapeReport';
// Register ChartJS
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

// User Info Modal
const UserInfoModal = ({ show, onSubmit, loading }) => {
  const { isDarkMode } = useTheme();
  const [formData, setFormData] = useState({
    name: "",
    email: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };
 


  return (
    <Modal
  show={show}
  centered
  backdrop="static"
  contentClassName={isDarkMode ? "bg-dark text-light" : ""}
>
  <Modal.Header className={`border-0 ${isDarkMode ? "bg-dark text-light" : ""}`}>
    <Modal.Title className="fw-bold">Start Security Scan</Modal.Title>
  </Modal.Header>

  <Modal.Body className={isDarkMode ? "bg-dark text-light" : ""}>
    <Form onSubmit={handleSubmit}>
      
      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">Your Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter your name"
          value={formData.name}
          onChange={(e) => setFormData({...formData, name: e.target.value})}
          required
          className={isDarkMode ? "bg-secondary text-light border-0" : ""}
        />
        <Form.Text className="text-muted">
          Required to associate scan with you
        </Form.Text>
      </Form.Group>

      <Form.Group className="mb-4">
        <Form.Label className="fw-semibold">Email Address</Form.Label>
        <Form.Control
          type="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={(e) => setFormData({...formData, email: e.target.value})}
          required
          className={isDarkMode ? "bg-secondary text-light border-0" : ""}
        />
        <Form.Text className="text-muted">
          Required for scan notifications and results
        </Form.Text>
      </Form.Group>

      <Button
        type="submit"
        variant="primary"
        size="lg"
        className="w-100"
        disabled={loading}
      >
        {loading ? (
          <>
            <Spinner size="sm" className="me-2" />
            Starting Scan...
          </>
        ) : (
          "🚀 Start Security Scan"
        )}
      </Button>

    </Form>
  </Modal.Body>
</Modal>
  );
};

// Export Modal
const ExportModal = ({ show, progress, onClose }) => {
  if (!show) return null;
  
  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className={`modal-title fw-bold `}>Generating PDF Report</h5>
          </div>
          <div className="modal-body">
            <div className="text-center">
              <Spinner animation="border" variant="primary" className="mb-3" />
              <p className="mb-2 fw-medium">Processing report layout and charts...</p>
              <ProgressBar 
                animated 
                now={progress} 
                label={`${progress}%`}
                className="mb-3"
                style={{ height: '10px' }}
              />
              <small className="">
                {progress < 30 && "Preparing document structure..."}
                {progress >= 30 && progress < 60 && "Rendering charts and graphs..."}
                {progress >= 60 && progress < 90 && "Compiling findings..."}
                {progress >= 90 && "Finalizing PDF document..."}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PublicScan = () => {
  const { token } = useParams();
  const { isDarkMode } = useTheme();
  const pdfContentRef = useRef(null);
  const doughnutChartRef = useRef(null);
const barChartRef = useRef(null);
  
  const [config, setConfig] = useState(null);
  const [results, setResults] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [scanning, setScanning] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);
  const [error, setError] = useState("");
  const [unlocking, setUnlocking] = useState(false);
  const [scanProgress, setScanProgress] = useState(0);
  const [activeAccordions, setActiveAccordions] = useState([]);
  const [toast, setToast] = useState({ show: false, message: '', type: 'info' });
  
   const elementsToHide = document.querySelectorAll(
  '.no-export, button, .btn, .progress-bar, .text-md-end'
);

const [state,setState]=useState("loading")
const [states, setStates] = useState({
      loading: true,
      progress: 0,
      loadingMessage: 'Initializing scan...',
      error: null,
      results: null,
      domain: null,
      isBlurred: true,
      leadCollected: false,
      showUnlockButton: false,
      
    });
    const [showUnlockModal, setShowUnlockModal] = useState(false);
      const unlockButtonRef = useRef(null);

  
    
    

    const [leadForm, setLeadForm] = useState({ name: '', phone: '', email: '', company: '' });
useEffect(() => {
      const checkVisibility = () => {
        if (!states.isBlurred || states.leadCollected || !states.results) {
          setStates(prev => ({ ...prev, showUnlockButton: false }));
          return;
        }

        const blurredCards = document.querySelectorAll('.blurred-card');
        if (!blurredCards.length) {
          setStates(prev => ({ ...prev, showUnlockButton: false }));
          return;
        }

        let shouldShow = false;
        blurredCards.forEach(card => {
          const rect = card.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
          if (isVisible) shouldShow = true;
        });
        setStates(prev => ({ ...prev, showUnlockButton: shouldShow }));
      };

      window.addEventListener('scroll', checkVisibility);
      return () => window.removeEventListener('scroll', checkVisibility);
    }, [states.isBlurred, states.leadCollected, states.results]);


  // Initialize accordions
  useEffect(() => {
    if (results?.categories) {
      setActiveAccordions(results.categories.map((_, i) => i.toString()));
    }
  }, [results]);

  // Set body theme
  useEffect(() => {
    document.body.className = isDarkMode 
      ? "bg-dark text-light" 
      : "bg-light text-dark";
  }, [isDarkMode]);

  // Fetch scan config
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await apifetch(`/s2/public/scan/${token}`);
        if (!res.ok) throw new Error("Invalid or expired scan link");
        const data = await res.json();
        setConfig(data);
        
        // Check if user info exists in config
        if (data.userName && data.userEmail) {
          setUserInfo({
            name: data.userName,
            email: data.userEmail
          });
        }
      } catch (err) {
        setError(err.message || "Failed to load scan configuration");
      } finally {
        setLoading(false);
      }
    };
    fetchConfig();
  }, [token]);
  async function getPublicIP() {
    try {
        const response = await fetch("https://api.ipify.org?format=json");

        if (!response.ok) {
            throw new Error("Failed to retrieve public IP");
        }

        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error("Unable to get public IP:", error);
        return null;
    }
}

  // Start scan with user info
  const handleStartScan = async () => {
    try {
      setShowUserModal(false);
      setScanning(true);
      setState('loading')
      setScanProgress(0);
      let progressInterval;
      // Progress simulation
      const messages = [
          'Analyzing DNS records...',
          'Checking SSL/TLS certificates...',
          'Scanning security headers...',
          'Analyzing email security...',
          'Checking infrastructure...',
          'Detecting typosquatting domains...',
          'Finalizing security report...'
        ];

        progressInterval = setInterval(() => {
          setStates(prev => {
            if (prev.progress >= 98) return prev;
            // Slower, more consistent increments
            const nextProgress = prev.progress + (Math.random() * 2 + 0.5);
            const msgIndex = Math.min(Math.floor((nextProgress / 100) * messages.length), messages.length - 1);
            return {
              ...prev,
              progress: Math.min(nextProgress, 98),
              loadingMessage: messages[msgIndex]
            };
          });
        }, 500);
      
        const public_ip=await getPublicIP()

      // Start scan with user info in request body
      const res = await apifetch(`/s2/public/scan/${token}/start`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json"
        },
         body: JSON.stringify({
          public_ip:public_ip,
        }),
      });
      
      clearInterval(progressInterval);
      
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || "Scan failed to start");
      }
      
      const data = await res.json();
      setResults(data);
      setState('result')
      setScanProgress(100);
        setStates(prev => ({
          ...prev,
          progress: 100,
          loadingMessage: 'Analysis Complete!'
        }));

        await new Promise(r => setTimeout(r, 800));

        setStates(prev => ({
          ...prev,
          results:data,
          loading: false,
          error: null,
          isBlurred: true,
          leadCollected: false
        }));
      
      setTimeout(() => setScanning(false), 1000);
    } catch (err) {
      setError(err.message);
      setScanning(false);
      setScanProgress(0);
      setState('initial')
    }
  };

  useEffect(() => {
    handleStartScan();
  }, []);

  const isValidEmail = (email) => {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    };
  const handleLeadSubmit = async (e) => {
        e.preventDefault();
        setUnlocking(true);

        const { name, phone, email } = leadForm;

        if (!name || !phone || !email) {
          showToast('Please fill in all fields', 'error');
          return;
        }
  
        if (!isValidEmail(email)) {
          showToast('Please enter a valid email', 'error');
          return;
        }
  
        try {
          if (states.results) {
            await apifetch(`/s2/public/scan/${token}/start`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
                            },
              body: JSON.stringify({
                name,
                phone,
                email,
                save: true,
                providedResults: states.results
              })
            }).catch(err => console.warn('Lead capture failed:', err));
          }else{
            showToast('No results available to save.', 'error');
          }
  
          setStates(prev => ({
            ...prev,
            leadCollected: true,
            isBlurred: false,
            showUnlockButton: false
          }));
  
          setShowUnlockModal(false);
          showToast('Thank you! Your report is now unlocked.', 'success');
  
        } catch (error) {
          showToast('Failed to submit. Please try again.', 'error');
        }

        setUnlocking(false);
      };

  // Severity stats
  const severityStats = useMemo(() => {
    if (!results?.categories) return { critical: 0, high: 0, medium: 0, low: 0 };
    
    const stats = { critical: 0, high: 0, medium: 0, low: 0 };
    results.categories.forEach(category => {
      category.findings?.forEach(finding => {
        const severity = finding.severity?.toLowerCase();
        if (stats.hasOwnProperty(severity)) {
          stats[severity]++;
        }
      });
    });
    return stats;
  }, [results]);

  // Total findings
  const totalFindings = useMemo(() => {
    return Object.values(severityStats).reduce((a, b) => a + b, 0);
  }, [severityStats]);

  // Chart data
  const donutData = {
    labels: ["Critical", "High", "Medium", "Low"],
    datasets: [{
      data: [
        severityStats.critical || 0,
        severityStats.high || 0,
        severityStats.medium || 0,
        severityStats.low || 0
      ],
      backgroundColor: [
        "#dc3545",
        "#fd7e14",
        "#ffc107",
        "#198754"
      ],
      borderColor: isDarkMode ? "#2d3748" : "#ffffff",
      borderWidth: 3,
      hoverOffset: 20
    }]
  };

  const barData = {
    labels: results?.categories?.map(c => c.name) || [],
    datasets: [{
      label: "Findings",
      data: results?.categories?.map(c => c.findings?.length || 0) || [],
      backgroundColor: isDarkMode 
        ? "rgba(59, 130, 246, 0.8)" 
        : "rgba(37, 99, 235, 0.8)",
      borderColor: isDarkMode ? "#3b82f6" : "#2563eb",
      borderWidth: 2,
      borderRadius: 6,
    }]
  };

  // Chart options
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: isDarkMode ? '#e2e8f0' : '#4a5568',
          font: { size: 12 }
        }
      },
      tooltip: {
        backgroundColor: isDarkMode ? '#2d3748' : '#ffffff',
        titleColor: isDarkMode ? '#e2e8f0' : '#2d3748',
        bodyColor: isDarkMode ? '#cbd5e0' : '#4a5568',
        borderColor: isDarkMode ? '#4a5568' : '#e2e8f0',
        borderWidth: 1,
        cornerRadius: 6
      }
    }
  };
  
  const getRiskLevel = (score) => {
      if (score >= 75) return 'low';
      if (score >= 60) return 'medium';
      if (score >= 40) return 'high';
      return 'critical';
    };

const getSeverityStats = (categories = []) => {
  const stats = { critical:0, high:0, medium:0, low:0 };
  categories.forEach(cat =>
    cat.findings?.forEach(f => {
      const s = f.severity?.toLowerCase();
      if (stats[s] !== undefined) stats[s]++;
    })
  );
  return stats;
};


const showToast = (message, type = 'info') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'info' }), 3000);
  };
const renderResults = () => {
      if (!results) return null;

      const data = results;
      const totalFindings = data.categories?.reduce((sum, cat) => sum + (cat.findings?.length || 0), 0) || 0;
      const criticalCount = data.categories?.reduce((sum, cat) => sum + (cat.findings?.filter(f => f.severity === 'critical')?.length || 0), 0) || 0;
      const highCount = data.categories?.reduce((sum, cat) => sum + (cat.findings?.filter(f => f.severity === 'high')?.length || 0), 0) || 0;
      const mediumCount = data.categories?.reduce((sum, cat) => sum + (cat.findings?.filter(f => f.severity === 'medium')?.length || 0), 0) || 0;
      const lowCount = data.categories?.reduce((sum, cat) => sum + (cat.findings?.filter(f => f.severity === 'low')?.length || 0), 0) || 0;

      // Security Score comes from the backend (100 = risk free, 0 = critical).
      const riskLevel = riskBandFor(data);

      return (
        <div className="results-page bg-light">
          <div className="results-container full-width">
            <div className="results-wrapper fade-in">
                          {/* Risk Score Card */}
              <div className={`risk-score-card ${riskLevel}`}>
                <div className="score-header">
                  <div className="domain-info">
                    <span className="domain-icon">🌐</span>
                    <div>
                      <h3 className="domain-name">{results.domain}</h3>
                      <p className="scan-time">Scanned just now</p>
                    </div>
                  </div>
                  <div className={`risk-badge ${riskLevel}`}>{riskLevel.toUpperCase()} RISK </div>
                </div>

                <div className="score-display">
                  <div className="score-number">{data.riskScore}</div>
                  <div className="score-out-of">/100</div>

                </div>

                <div className="score-meter" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                  <div style={{ flex: 1 }}>
                    <div className="meter-track">
                      <div className={`meter-fill ${riskLevel}`} style={{ width: `${data.riskScore}%` }}></div>
                    </div>
                    <div className="severity-summary">
                      <div className="severity-item"><span className="severity-dot critical"></span>Critical: {criticalCount}</div>
                      <div className="severity-item"><span className="severity-dot high"></span>High: {highCount}</div>
                      <div className="severity-item"><span className="severity-dot medium"></span>Medium: {mediumCount}</div>
                      <div className="severity-item"><span className="severity-dot low"></span>Low: {lowCount}</div>
                    </div>
                  </div>
                  {states.leadCollected && (
                    <button
                      className="download-btn"
                      onClick={exportPdf}
                      style={{
                        padding: '10px 20px',
                        fontSize: '13px',
                        height: 'auto',
                        boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)',
                        marginLeft: '24px',
                        flexShrink: 0
                      }}
                      disabled={exporting}
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" width="18" height="18">
                        <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 4v12m0 0l-4-4m4 4l4-4"
                          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span style={{ fontWeight: '700', letterSpacing: '0.5px' }}>DOWNLOAD REPORT</span>
                    </button>
                  )}
                </div>
              </div>
              {/* Stats Grid */}
              <div className="stats-grid">
                <div className="stat-card">
                  <div className="stat-icon">📊</div>
                  <div className="stat-value">{data.categories?.length || 0}</div>
                  <div className="stat-label">Categories</div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">🔍</div>
                  <div className="stat-value">{totalFindings}</div>
                  <div className="stat-label">Total Finding</div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">⚠️</div>
                  <div className="stat-value">{criticalCount + highCount}</div>
                  <div className="stat-label">Critical/High</div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">📋</div>
                  <div className="stat-value">{getGrade(data.riskScore)}</div>
                  <div className="stat-label">Security Grade</div>
                </div>
              </div>

              {/* Security Categories Section - First 3 visible, last 2 blurred */}
              <div className="categories-section">
                <h2 className="section-title-large">Security Findings by Category</h2>
                <div className="categories-grid">
                  {data.categories?.map((category, index) => (
                    <div
                      key={index}
                      className={`category-card} ${states.isBlurred && index >= 3 ? 'blurred-card' : ''}`}
                    >
                      <div className="category-header">
                        <div className="category-title">
                          {/* <span className="category-icon">{category.icon || '🔍'}</span> */}
                          <h3>{category.name}</h3>
                        </div>
                        <span className="finding-count">{category.findings?.length || 0} findings</span>
                      </div>
                      <div className="findings-list">
                        {category.findings?.map((finding, idx) => (
                          <div key={idx} className="finding-item">
                            <div className={`finding-severity severity-${finding.severity}`}>
                              {finding.severity === 'critical' ? '🔴' :
                                finding.severity === 'high' ? '🟠' :
                                  finding.severity === 'medium' ? '🟡' : '🔵'}
                            </div>
                            <div className="finding-details">
                              <div className="finding-title">{finding.title}</div>
                              <div className="finding-description">
                                {finding.description}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>

          {states.isBlurred && !states.leadCollected && states.results && (
            <button
              ref={unlockButtonRef}
              className="fixed-unlock-btn"
              onClick={() => setShowUnlockModal(true)}
              style={{ display: states.showUnlockButton ? 'flex' : 'none' }}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" width="24" height="24">
                <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>Unlock Full Report</span>
            </button>
          )}

           {showUnlockModal && (
            <>
              <div className="unlock-modal-overlay" onClick={() => setShowUnlockModal(false)}></div>
              <div className="unlock-modal">
                <div className="unlock-modal-content">
                  <button className="unlock-modal-close" onClick={() => setShowUnlockModal(false)}>&times;</button>
                  <div className="unlock-modal-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <h3 className="unlock-modal-title">Unlock Full Report</h3>
                  <p className="unlock-modal-subtitle">
                    Enter your details to access the complete security analysis
                  </p>

                  <form className="unlock-modal-form" onSubmit={handleLeadSubmit}>
                    <div className="form-group">
                      <input
                        type="text"
                        className="modal-form-input"
                        placeholder="Full Name"
                        value={leadForm.name}
                        onChange={(e) => setLeadForm({ ...leadForm, name: e.target.value })}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="tel"
                        className="modal-form-input"
                        placeholder="Phone Number"
                        value={leadForm.phone}
                        onChange={(e) => setLeadForm({ ...leadForm, phone: e.target.value })}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="email"
                        className="modal-form-input"
                        placeholder="Email Address"
                        value={leadForm.email}
                        onChange={(e) => setLeadForm({ ...leadForm, email: e.target.value })}
                        required
                      />
                    </div>
                    
                    {config.collectCompany && (
                      <div className="form-group">
                        <input 
                          type="text" 
                          className="modal-form-input" 
                          placeholder="Company Name (optional)"
                          value={leadForm.company}
                          onChange={(e) => setLeadForm({ ...leadForm, company: e.target.value })}
                        />
                      </div>
                    )}
                    <button type="submit" disabled={unlocking} className="unlock-modal-btn">
                      <span>{ unlocking ? 'Unlocking...' : 'Unlock Now' }</span>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M13 7l5 5m0 0l-5 5m5-5H6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </form>
                  <p className="unlock-modal-note">Your information is secure and never shared</p>
                </div>
              </div>
            </>
          )}
           {toast.show && (
            <div className={`toast toast-${toast.type} show`}>
              <div className="toast-icon">
                {toast.type === 'success' ? '✓' : toast.type === 'error' ? '✕' : 'ℹ'}
              </div>
              <div className="toast-message">{toast.message}</div>
            </div>
          )}
          
        </div>
      );
    };

const renderSkeletonLoader = () => (
      <div className="results-page bg-light" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        background: 'var(--bg-gradient)'
      }}>
        <div className="loading-content" style={{
          textAlign: 'center',
          maxWidth: '500px',
          width: '90%',
          padding: '60px 40px',
          borderRadius: '32px',
          background: 'rgba(255, 255, 255, 0.03)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 24px 48px rgba(0,0,0,0.4)',
          animation: 'loader-fade-in 0.8s ease-out'
        }}>
          <div className="loader-icon" style={{ marginBottom: '32px', position: 'relative' }}>
            <div className="pulse-ring" style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '140px',
              height: '140px',
              borderRadius: '50%',
              border: '2px solid var(--primary)',
              opacity: '0.3',
              animation: 'loader-pulse 2s infinite'
            }}></div>
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(5px)'
            }}>
              <svg viewBox="0 0 24 24" width="40" height="40" stroke="var(--primary)" fill="none" strokeWidth="1.5" style={{ filter: 'drop-shadow(0 0 12px var(--primary))' }}>
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <path d="M12 8v4l3 3" opacity="0.6" />
              </svg>
            </div>
          </div>

          <h2 style={{
            fontSize: '28px',
            fontWeight: '800',
            marginBottom: '12px',
            letterSpacing: '-1px',
            WebkitBackgroundClip: 'text',
            color: '#94a3b8',
          }}>
            Generating report
          </h2>

          <p style={{
            fontSize: '15px',
            color: 'var(--text-muted)',
            marginBottom: '40px',
            height: '24px',
            transition: 'all 0.3s ease',
            letterSpacing: '0.5px'
          }}>
            {states.loadingMessage}
          </p>

          <div className="progress-wrapper" style={{ position: 'relative', marginBottom: '20px' }}>
            <div style={{
              height: '12px',
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '100px',
              overflow: 'hidden',
              border: '1px solid rgba(255,255,255,0.05)',
              boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.2)'
            }}>
              <div style={{
                width: `${states.progress}%`,
                height: '100%',
                background: 'linear-gradient(90deg, var(--primary), #60a5fa)',
                boxShadow: '0 0 20px var(--primary)',
                borderRadius: '100px',
                transition: 'width 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)'
              }}></div>
            </div>
          </div>

          <div style={{
            fontSize: '48px',
            fontWeight: '900',
            color: isDarkMode?'white':'black',
            fontVariantNumeric: 'tabular-nums',
            textShadow: '0 0 20px rgba(255,255,255,0.2)'
          }}>
            {Math.round(states.progress)}<span style={{ fontSize: '20px', opacity: 0.5 }}>%</span>
          </div>
        </div>

        <style>{`
          @keyframes loader-pulse {
            0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.5; }
            100% { transform: translate(-50%, -50%) scale(1.4); opacity: 0; }
          }
          @keyframes loader-fade-in {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>
      </div>
    );
const getGrade = (score) => {
      if (score >= 90) return 'A+';
      if (score >= 80) return 'A';
      if (score >= 75) return 'B+';
      if (score >= 70) return 'B';
      if (score >= 60) return 'C';
      if (score >= 40) return 'D';
      return 'F';
    };
 const exportPdf = async () => {
    if (!results) {
      showToast('No result available', 'error');
      return;
    }

    setExporting(true);


    showToast('Generating security report...', 'info');

    try {
      const domain = config.target.replace(/^https?:\/\//, '').split('/')[0];
      const isCyberMode = false;

      // ===== DEFINE ALL STATS AND VARIABLES FIRST =====
      // Get severity stats
      const getSeverityStats = (categories) => {
        const stats = { critical: 0, high: 0, medium: 0, low: 0 };
        categories?.forEach(cat => {
          cat.findings?.forEach(f => {
            const s = f.severity?.toLowerCase();
            if (stats[s] !== undefined) stats[s]++;
          });
        });
        return stats;
      };

      // Get risk level with futuristic colors
      const getRiskLevelWithColor = (score) => {
        if (score >= 75) return {
          label: 'LOW',
          color: '#2ec4b6',
          gradient: 'linear-gradient(135deg, #2ec4b6 0%, #6cdfd3 100%)',
          glow: '0 0 20px rgba(46, 196, 182, 0.5)'
        };
        if (score >= 60) return {
          label: 'MEDIUM',
          color: '#eab308',
          gradient: 'linear-gradient(135deg, #eab308 0%, #facc15 100%)',
          glow: '0 0 20px rgba(234, 179, 8, 0.5)'
        };
        if (score >= 40) return {
          label: 'HIGH',
          color: '#ff9f1c',
          gradient: 'linear-gradient(135deg, #ff9f1c 0%, #ffbf69 100%)',
          glow: '0 0 20px rgba(255, 159, 28, 0.5)'
        };
        return {
          label: 'CRITICAL',
          color: '#ff3b6f',
          gradient: 'linear-gradient(135deg, #ff3b6f 0%, #ff8e8e 100%)',
          glow: '0 0 20px rgba(255, 59, 111, 0.5)'
        };
      };

      // Get favicon URL
      const getFaviconUrl = (domain) => {
        try {
          const clean = domain.replace(/^https?:\/\//, '').split('/')[0];
          return `https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://${clean}&size=128`;
        } catch {
          return null;
        }
      };


      // ===== CALCULATE STATS ONCE =====

      // 1. Collect and De-duplicate findings globally based on title and description
      const uniqueFindingsMap = new Map();
      results.categories?.forEach(cat => {
        cat.findings?.forEach(f => {
          const key = `${f.title?.trim()}-${f.description?.trim()}`.toLowerCase();
          if (!uniqueFindingsMap.has(key)) {
            // Normalize severity: default to low if missing/unknown
            let severity = f.severity?.toLowerCase() || 'low';
            if (!['critical', 'high', 'medium', 'low'].includes(severity)) {
              severity = 'low';
            }
            uniqueFindingsMap.set(key, {
              ...f,
              severity,
              category: cat.name,
              icon: cat.icon
            });
          }
        });
      });
      const allFindings = Array.from(uniqueFindingsMap.values());

      // 2. Sort findings by category then severity priority
      const severityPriority = { critical: 0, high: 1, medium: 2, low: 3 };
      allFindings.sort((a, b) => {
        if (a.category !== b.category) {
          return a.category.localeCompare(b.category);
        }
        return (severityPriority[a.severity] ?? 99) - (severityPriority[b.severity] ?? 99);
      });

      // 3. Calculate global stats from unique findings
      const stats = { critical: 0, high: 0, medium: 0, low: 0 };
      allFindings.forEach(f => {
        stats[f.severity]++;
      });

      const totalFindings = allFindings.length;
      const criticalCount = stats.critical;
      const highCount = stats.high;
      const mediumCount = stats.medium;
      const lowCount = stats.low;

      // 4. Re-map categories to only contain their unique findings for the table
      const normalizedCategories = results.categories?.map(cat => {
        const catFindings = allFindings.filter(f => f.category === cat.name);
        return { ...cat, findings: catFindings };
      }).filter(cat => cat.findings.length > 0);

      // 5. Security Score — from the backend, not recomputed. The old averaging model here
      // counted passing checks as 100 points each and overwrote results.riskScore.
      // 100 = risk free, 0 = critical.
      const calculatedRiskScore = Number.isFinite(results.riskScore) ? results.riskScore : 100;
      // Style tier follows the clamped band (see shapeReport.riskBandFor).
      const risk = getRiskLevelWithColor(bandStyleScore(riskBandFor(results, calculatedRiskScore)));

      // Futuristic gradient backgrounds
      const getBgGradient = () => {
        if (isCyberMode) {
          return 'linear-gradient(135deg, #0a0a0f 0%, #1a1a2e 100%)';
        }
        if (isDarkMode) {
          return 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)';
        }
        return 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)';
      };

      const getCardGradient = () => {
        if (isCyberMode) {
          return 'linear-gradient(135deg, rgba(0, 255, 136, 0.1) 0%, rgba(123, 97, 255, 0.1) 100%)';
        }
        if (isDarkMode) {
          return 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)';
        }
        return 'linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)';
      };

      // Build futuristic executive summary
      const buildExecutiveSummary = () => {
        const mostSevere = Object.entries(stats)
          .sort((a, b) => b[1] - a[1])[0] || ['low', 0];

        const criticalPct = totalFindings
          ? Math.round(((stats.critical + stats.high) / totalFindings) * 100)
          : 0;

        return `
        <div style="
          margin-top: 28px;
          padding: 28px;
          border-radius: 24px;
          background: ${getCardGradient()};
          border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'};
          backdrop-filter: blur(10px);
          box-shadow: 0 8px 32px rgba(0,0,0,0.1);
          position: relative;
          overflow: hidden;
        ">
          <div style="
            position: absolute;
            top: 0;
            right: 0;
            width: 200px;
            height: 200px;
            background: radial-gradient(circle, ${risk.color}15 0%, transparent 70%);
            border-radius: 50%;
            transform: translate(50px, -50px);
          "></div>
          
          <div style="position: relative; z-index: 1;">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
              <div style="
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: ${risk.color};
                box-shadow: ${risk.glow};
              "></div>
              <span style="
                font-size: 14px;
                font-weight: 600;
                letter-spacing: 2px;
                text-transform: uppercase;
                color: ${risk.color};
              ">Executive Analysis</span>
            </div>
            
            <h3 style="
              margin: 0 0 16px;
              font-size: 28px;
              color:${isDarkMode ? '#0f172a' : '#f1f5f9'};
              font-weight: 700;
              letter-spacing: -0.5px;
              background: linear-gradient(135deg, ${isDarkMode ? '#fff' : '#0f172a'}, ${risk.color});
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            ">
              Security Posture Assessment
            </h3>
            
            <p style="
              font-size: 15px;
              line-height: 1.7;
              color: ${isDarkMode ? '#e2e8f0' : '#334155'};
              margin-bottom: 20px;
            ">
              <span style="
                display: inline-block;
                padding: 4px 12px;
                border-radius: 100px;
                background: ${risk.color}20;
                color: ${risk.color};
                font-weight: 700;
                margin-right: 8px;
              ">${domain}</span>
              exhibits a <strong style="color: ${risk.color};">${risk.label}</strong> risk profile 
              with a security score of <strong style="color: ${risk.color};">${results.riskScore || 50}/100</strong>.
            </p>

            <div style="
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 16px;
              margin-top: 24px;
            ">
              <div style="
                padding: 16px;
                border-radius: 16px;
                background: ${isDarkMode ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)'};
                border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'};
              ">
                <div style="font-size: 28px; font-weight: 800; color: ${risk.color}; margin-bottom: 4px;">
                  ${criticalPct}%
                </div>
                <div style="font-size: 12px; opacity: 0.7; color: ${isDarkMode ? '#94a3b8' : '#64748b'};">
                  High-Impact Issues
                </div>
              </div>
              <div style="
                padding: 16px;
                border-radius: 16px;
                background: ${isDarkMode ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)'};
                border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'};
              ">
                <div style="font-size: 28px; font-weight: 800; color: ${risk.color}; margin-bottom: 4px;">
                  ${mostSevere[1]}
                </div>
                <div style="font-size: 12px; opacity: 0.7; color: ${isDarkMode ? '#94a3b8' : '#64748b'};">
                  ${mostSevere[0].toUpperCase()} Severity Issues
                </div>
              </div>
              <div style="
                padding: 16px;
                border-radius: 16px;
                background: ${isDarkMode ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)'};
                border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'};
              ">
                <div style="font-size: 28px; font-weight: 800; color: ${risk.color}; margin-bottom: 4px;">
                  ${stats.critical}
                </div>
                <div style="font-size: 12px; opacity: 0.7; color: ${isDarkMode ? '#94a3b8' : '#64748b'};">
                  Critical Vulnerabilities
                </div>
              </div>
            </div>

            <div style="
              margin-top: 24px;
              padding: 20px;
              border-radius: 16px;
              background: ${isDarkMode ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.5)'};
              border-left: 4px solid ${risk.color};
            ">
              <div style="display: flex; gap: 12px; align-items: flex-start;">
                <div style="font-size: 20px;">⚡</div>
                <div>
                  <div style="font-weight: 700; margin-bottom: 4px; color: ${isDarkMode ? '#f1f5f9' : '#0f172a'};">
                    ${stats.critical ? 'Immediate Action Required' : 'Proactive Security Posture'}
                  </div>
                  <div style="font-size: 13px; color: ${isDarkMode ? '#94a3b8' : '#64748b'};">
                    ${stats.critical
            ? `${stats.critical} critical vulnerabilities require immediate remediation to prevent potential breaches.`
            : `No critical vulnerabilities detected. Continue maintaining strong security practices.`
          }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
      };

      // Futuristic info card
      const infoCard = (label, value, icon) => `
      <div style="
        padding: 20px;
        border-radius: 20px;
        background: ${getCardGradient()};
        border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'};
        backdrop-filter: blur(10px);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
      ">
        <div style="
          position: absolute;
          top: 0;
          right: 0;
          width: 100px;
          height: 100px;
          background: radial-gradient(circle, ${isDarkMode ? '#8b5cf620' : '#8b5cf610'} 0%, transparent 70%);
          border-radius: 50%;
          transform: translate(30px, -30px);
        "></div>
        <div style="position: relative; z-index: 1;">
          <div style="font-size: 24px; margin-bottom: 8px;">${icon}</div>
          <div style="font-size: 11px; text-transform: uppercase; letter-spacing: 1px; opacity: 0.6; color: ${isDarkMode ? '#94a3b8' : '#64748b'}; margin-bottom: 4px;">
            ${label}
          </div>
          <div style="font-size: 16px; font-weight: 700; color: ${isDarkMode ? '#f1f5f9' : '#0f172a'}; word-break: break-word;">
            ${value}
          </div>
        </div>
      </div>
    `;

      // Severity badge
      const severityBadge = (severity, count) => {
        const colors = {
          critical: { bg: '#ff3b6f20', color: '#ff3b6f', icon: '🔴' },
          high: { bg: '#ff9f1c20', color: '#ff9f1c', icon: '🟠' },
          medium: { bg: '#eab30820', color: '#eab308', icon: '🟡' },
          low: { bg: '#2ec4b620', color: '#2ec4b6', icon: '🔵' }
        };
        const c = colors[severity] || colors.low;

        return `
        <div style="
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 6px 14px;
          border-radius: 100px;
          background: ${c.bg};
          border: 1px solid ${c.color}30;
        ">
          <span style="font-size: 14px;">${c.icon}</span>
          <span style="font-size: 13px; font-weight: 600; color: ${c.color};">${count}</span>
          <span style="font-size: 12px; opacity: 0.8; color: ${isDarkMode ? '#e2e8f0' : '#334155'};">${severity}</span>
        </div>
      `;
      };

      // Build category row with futuristic design
      const buildRow = (cat) => {
        const catStats = { critical: 0, high: 0, medium: 0, low: 0 };
        cat.findings?.forEach(f => {
          const s = f.severity?.toLowerCase();
          if (catStats[s] !== undefined) catStats[s]++;
        });
        const total = Object.values(catStats).reduce((a, b) => a + b, 0);

        return `
        <tr style="
          background: ${isDarkMode ? 'rgba(255,255,255,0.02)' : 'rgba(255,255,255,0.5)'};
          border-bottom: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)'};
          transition: all 0.2s ease;
        ">
          <td style="
            padding: 16px 12px;
            font-weight: 600;
            color: ${isDarkMode ? '#f1f5f9' : '#0f172a'};
            border-radius: 12px 0 0 12px;
          ">
            <div style="display: flex; align-items: center; gap: 8px;">
              <span style="font-size: 20px;">${cat.icon || '🔍'}</span>
              <span>${cat.name}</span>
            </div>
          </td>
          <td align="center" style="padding: 16px 12px;">
            <span style="
              display: inline-block;
              padding: 4px 10px;
              border-radius: 100px;
              background: ${catStats.critical ? '#ff3b6f20' : 'transparent'};
              color: ${catStats.critical ? '#ff3b6f' : '#9ca3af'};
              font-weight: ${catStats.critical ? '700' : '400'};
            ">${catStats.critical || '0'}</span>
          </td>
          <td align="center" style="padding: 16px 12px;">
            <span style="
              display: inline-block;
              padding: 4px 10px;
              border-radius: 100px;
              background: ${catStats.high ? '#ff9f1c20' : 'transparent'};
              color: ${catStats.high ? '#ff9f1c' : '#9ca3af'};
              font-weight: ${catStats.high ? '700' : '400'};
            ">${catStats.high || '0'}</span>
          </td>
          <td align="center" style="padding: 16px 12px;">
            <span style="
              display: inline-block;
              padding: 4px 10px;
              border-radius: 100px;
              background: ${catStats.medium ? '#eab30820' : 'transparent'};
              color: ${catStats.medium ? '#eab308' : '#9ca3af'};
              font-weight: ${catStats.medium ? '700' : '400'};
            ">${catStats.medium || '0'}</span>
          </td>
          <td align="center" style="padding: 16px 12px;">
            <span style="
              display: inline-block;
              padding: 4px 10px;
              border-radius: 100px;
              background: ${catStats.low ? '#2ec4b620' : 'transparent'};
              color: ${catStats.low ? '#2ec4b6' : '#9ca3af'};
              font-weight: ${catStats.low ? '700' : '400'};
            ">${catStats.low || '0'}</span>
          </td>
          <td align="center" style="
            padding: 16px 12px;
            font-weight: 800;
            color: ${isDarkMode ? '#a78bfa' : '#8b5cf6'};
            border-radius: 0 12px 12px 0;
          ">
            <span style="
              display: inline-block;
              padding: 4px 12px;
              background: ${isDarkMode ? '#8b5cf620' : '#8b5cf610'};
              border-radius: 100px;
            ">${total}</span>
          </td>
        </tr>
      `;
      };

      // Create paginated content with perfect breaks
      const createPaginatedContent = () => {
        const pages = [];

        // PAGE 1 - Cover and Summary
        let page1 = `
        <div style="
          color: ${isDarkMode ? '#f1f5f9' : '#0f172a'};
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          position: relative;
        ">
          <!-- Futuristic Header -->
          <div style="
            position: relative;
            padding: 32px 32px 28px;
            border-radius: 32px;
            background: ${isCyberMode
            ? 'linear-gradient(135deg, #00ff8820 0%, #7b61ff20 100%)'
            : `linear-gradient(135deg, ${isDarkMode ? '#1e293b' : '#8b5cf6'}, ${isDarkMode ? '#0f172a' : '#7c3aed'})`
          };
            color: white;
            margin-bottom: 28px;
            overflow: hidden;
            box-shadow: 0 20px 40px rgba(0,0,0,0.2);
          ">
            <div style="
              position: absolute;
              top: -50px;
              right: -50px;
              width: 200px;
              height: 200px;
              background: radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%);
              border-radius: 50%;
            "></div>
            <div style="
              position: absolute;
              bottom: -50px;
              left: -50px;
              width: 150px;
              height: 150px;
              background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
              border-radius: 50%;
            "></div>
            
            <div style="position: relative; z-index: 1; display: flex; justify-content: space-between; align-items: center;">
              <div style="display:flex;align-items:center;gap:14px">
            <div>
                  <div style="
                    font-size: 14px;
                    font-weight: 600;
                    letter-spacing: 3px;
                    text-transform: uppercase;
                    opacity: 0.9;
                    margin-bottom: 8px;
                  ">SECURITY REPORT</div>
                  <h1 style="margin: 0; font-size: 36px; font-weight: 800; letter-spacing: -1px; line-height: 1.1;">
                    ${domain}
                  </h1>
                  <p style="margin-top: 8px; font-size: 15px; opacity: 0.9; display: flex; align-items: center; gap: 8px;">
                    <span>${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                    <span style="display: inline-block; width: 4px; height: 4px; background: white; border-radius: 50%; opacity: 0.5;"></span>
                  </p>
                </div>
              </div>
              
              <div style="
                text-align: right;
                background: rgba(255,255,255,0.1);
                padding: 20px;
                border-radius: 24px;
                backdrop-filter: blur(10px);
                border: 1px solid rgba(255,255,255,0.2);
              ">
                <div style="font-size: 56px; font-weight: 900; line-height: 1; letter-spacing: -2px;">
                  ${results.riskScore}<span style="font-size: 20px; opacity: 0.8;">/100</span>
                </div>
                <div style="
                  margin-top: 8px;
                  padding: 6px 16px;
                  border-radius: 100px;
                  background: ${risk.color}30;
                  color: white;
                  font-size: 14px;
                  font-weight: 700;
                  letter-spacing: 1px;
                ">
                  ${risk.label} RISK
                </div>
              </div>
            </div>
          </div>

          <!-- Info Grid -->
          <div style="
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 16px;
            margin-bottom: 24px;
          ">
            ${infoCard('Target', domain, '🌐')}
            ${infoCard('Scan Date', new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }), '📅')}
            ${infoCard('Total Findings', totalFindings.toString(), '⚠️')}
            ${infoCard('Risk Level', risk.label, risk.label === 'CRITICAL' ? '🔴' : risk.label === 'ELEVATED' ? '🟠' : '🟢')}
          </div>

          <!-- Executive Summary -->
          ${buildExecutiveSummary()}

          <!-- Severity Distribution -->
          <div style="
            margin-top: 28px;
            padding: 28px;
            border-radius: 24px;
            background: ${getCardGradient()};
            border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'};
            backdrop-filter: blur(10px);
            position: relative;
            overflow: hidden;
          ">
            <div style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 4px;
              background: linear-gradient(90deg, #ff3b6f, #ff9f1c, #eab308, #2ec4b6);
            "></div>
            
            <h3 style="
              margin: 0 0 24px;
              font-size: 20px;
              font-weight: 700;
              display: flex;
              align-items: center;
              color: ${isDarkMode ? '#ffffff' : '#171718'};
              gap: 12px;
            ">
              <span style="
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #8b5cf6;
                box-shadow: 0 0 20px #8b5cf6;
              "></span>
              Severity Distribution
            </h3>
            
            <div style="display: flex; justify-content: space-around; align-items: center;">
              ${severityBadge('critical', stats.critical)}
              ${severityBadge('high', stats.high)}
              ${severityBadge('medium', stats.medium)}
              ${severityBadge('low', stats.low)}
            </div>

          </div>
        </div>
      `;

        pages.push(page1);

        // PAGE 2 - Categories Summary (with proper spacing)
        let page2 = `
        <div style="
          color: ${isDarkMode ? '#f1f5f9' : '#0f172a'};
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          page-break-before: always;
          position: relative;
        ">
          <div style="
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 28px;
            padding-bottom: 16px;
            border-bottom: 2px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'};
          ">
            <div>
              <h2 style="
                margin: 0 0 8px;
                font-size: 28px;
                font-weight: 800;
                letter-spacing: -0.5px;
                color: ${isDarkMode ? '#ffffff' : '#171718'};
                margin:5px;
                padding:0 20px
                width: 100%;
              ">
                Security Categories
              </h2>
              <p style="margin: 0; font-size: 14px; opacity: 0.6; color: ${isDarkMode ? '#94a3b8' : '#64748b'};">
                Detailed analysis by security domain
              </p>
            </div>
            <div style="
              padding: 8px 16px;
              background: ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)'};
              border-radius: 100px;
              font-size: 13px;
              font-weight: 600;
            ">
              ${normalizedCategories?.length || 0} Categories · ${totalFindings} Total Findings
            </div>
          </div>

          <!-- Categories Table -->
          <div style="
            border-radius: 24px;
            overflow: hidden;
            border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'};
            margin-bottom: 28px;
          ">
            <table style="
              width: 100%;
              border-collapse: collapse;
              font-size: 14px;
            ">
              <thead>
                <tr style="
                  background: ${isDarkMode ? 'rgba(139, 92, 246, 0.2)' : '#f1f5f9'};
                  color: ${isDarkMode ? '#e2e8f0' : '#475569'};
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 11px;
                  letter-spacing: 1px;
                ">
                  <th style="padding: 16px 12px; text-align: left;">Category</th>
                  <th style="padding: 16px 12px; text-align: center;">Critical</th>
                  <th style="padding: 16px 12px; text-align: center;">High</th>
                  <th style="padding: 16px 12px; text-align: center;">Medium</th>
                  <th style="padding: 16px 12px; text-align: center;">Low</th>
                  <th style="padding: 16px 12px; text-align: center;">Total</th>
                </tr>
              </thead>
              <tbody>
                ${normalizedCategories?.map(buildRow).join('')}
              </tbody>
            </table>
          </div>
          <div id="page2-findings-area"></div>
      `;

        const MAX_PAGE_HEIGHT = 1000;
        const measureHeight = (html) => {
          const testDiv = document.createElement('div');
          testDiv.style.width = '794px';
          testDiv.style.padding = '40px';
          testDiv.style.boxSizing = 'border-box';
          testDiv.style.visibility = 'hidden';
          testDiv.style.position = 'absolute';
          testDiv.style.fontFamily = 'Inter, sans-serif';
          testDiv.innerHTML = html;
          document.body.appendChild(testDiv);
          const height = testDiv.offsetHeight;
          document.body.removeChild(testDiv);
          return height;
        };

        let lastCategory = null;
        const buildCategoryHeader = (category, isContinuation = false) => `
        <h3 style="
          margin: 32px 0 20px;
          color: ${isDarkMode ? '#ffffff' : '#171718'};
          font-size: 22px;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 12px;
        ">
          <span style="
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #8b5cf6;
            box-shadow: 0 0 20px #8b5cf6;
          "></span>
          ${category}${isContinuation ? ' <span style="font-size: 14px; opacity: 0.5; font-weight: 400;">(Continued)</span>' : ''}
        </h3>
        <p style="margin: -15px 0 20px 20px; font-size: 14px; opacity: 0.6; color: ${isDarkMode ? '#94a3b8' : '#64748b'};">
          ${isContinuation ? 'Continuation of security findings' : 'Analysis of findings in this category'}
        </p>
      `;

        const renderFindingCard = (finding) => {
          const severityColor = finding.severity === 'critical' ? '#ef4444' :
            finding.severity === 'high' ? '#f97316' :
              finding.severity === 'medium' ? '#eab308' : '#3b82f6';
          const severityIcon = finding.severity === 'critical' ? '🔴' :
            finding.severity === 'high' ? '🟠' :
              finding.severity === 'medium' ? '🟡' : '🔵';

          return `
          <div style="
            margin-bottom: 16px;
            padding: 20px;
            border-radius: 20px;
            background: ${getCardGradient()};
            border: 1px solid ${severityColor}40;
            position: relative;
            overflow: hidden;
            width: 100%;
            box-sizing: border-box;
          ">
            <div style="
              position: absolute;
              top: 0;
              left: 0;
              width: 4px;
              height: 100%;
              background: ${severityColor};
            "></div>
            <div style="display: flex; gap: 16px; margin-left: 8px;">
              <div style="font-size: 24px;">${severityIcon}</div>
              <div style="flex: 1;">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                  <span style="
                    font-weight: 700;
                    font-size: 16px;
                    color: ${isDarkMode ? '#f1f5f9' : '#0f172a'};
                  ">${finding.title}</span>
                   <div style="display: flex; gap: 8px; align-items: center;">
                    <span style="
                      padding: 4px 12px;
                      border-radius: 100px;
                      background: ${severityColor}20;
                      color: ${severityColor};
                      font-size: 11px;
                      font-weight: 700;
                      text-transform: uppercase;
                      letter-spacing: 1px;
                    ">${finding.severity}</span>
                    ${(finding.severity !== 'low' && finding.severity !== 'info') ? `
                    <span style="
                      padding: 4px 10px;
                      border-radius: 100px;
                      background: ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'};
                      color: ${isDarkMode ? '#94a3b8' : '#64748b'};
                      font-size: 10px;
                      font-weight: 700;
                      border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'};
                    ">IMPACT: ${finding.impact || (finding.severity === 'critical' ? '25' : finding.severity === 'high' ? '15' : '10')} PTS</span>
                    ` : ''}
                  </div>
                </div>
                <div style="
                  font-size: 13px;
                  color: ${isDarkMode ? '#94a3b8' : '#64748b'};
                  line-height: 1.6;
                ">${finding.description}</div>
                <div style="
                  margin-top: 12px;
                  font-size: 12px;
                  color: ${isDarkMode ? '#a78bfa' : '#8b5cf6'};
                  display: flex;
                  align-items: center;
                  gap: 6px;
                ">
                  <span>${finding.icon || '🔍'}</span>
                  <span>${finding.category}</span>
                </div>
              </div>
            </div>
          </div>
        `;
        };

        let page2FindingsHtml = '';
        let currentFindingsIndex = 0;

        for (let i = 0; i < allFindings.length; i++) {
          const finding = allFindings[i];
          let prospectiveHtml = page2FindingsHtml;
          let headerAdded = false;

          if (finding.category !== lastCategory) {
            prospectiveHtml += buildCategoryHeader(finding.category);
            headerAdded = true;
          }
          prospectiveHtml += renderFindingCard(finding);

          const fullPage2Height = measureHeight(page2 + prospectiveHtml);

          if (fullPage2Height > MAX_PAGE_HEIGHT) {
            break;
          } else {
            if (headerAdded) lastCategory = finding.category;
            page2FindingsHtml = prospectiveHtml;
            currentFindingsIndex = i + 1;
          }
        }

        pages.push(page2 + page2FindingsHtml);

        while (currentFindingsIndex < allFindings.length) {
          let currentPageHtml = '';
          let pageLastCategory = null;
          let itemsOnPage = 0;

          while (currentFindingsIndex < allFindings.length) {
            const finding = allFindings[currentFindingsIndex];
            let prospectiveHtml = currentPageHtml;
            let headerAdded = false;
            let isContinuation = false;

            if (finding.category !== pageLastCategory) {
              isContinuation = finding.category === lastCategory;
              prospectiveHtml += buildCategoryHeader(finding.category, isContinuation);
              headerAdded = true;
            }

            prospectiveHtml += renderFindingCard(finding);
            const h = measureHeight(prospectiveHtml);

            if (h > MAX_PAGE_HEIGHT && itemsOnPage > 0) {
              break;
            } else {
              if (headerAdded) {
                lastCategory = finding.category;
                pageLastCategory = finding.category;
              }
              currentPageHtml = prospectiveHtml;
              currentFindingsIndex++;
              itemsOnPage++;
            }
          }

          pages.push(`
          <div class="page" style="
            color: ${isDarkMode ? '#f1f5f9' : '#0f172a'};
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
            padding: 40px;
            width: 794px;
            box-sizing: border-box;
          ">
            <div style="width: 100%;">
              ${currentPageHtml}
            </div>
          </div>
        `);
        }

        return pages;
      };

      // Load PDF libraries if needed
      if (!window.html2canvas || !window.jspdf) {
        await loadPDFLibraries();
      }

      // Create temporary container
      const tempContainer = document.createElement('div');
      tempContainer.style.position = 'absolute';
      tempContainer.style.left = '-9999px';
      tempContainer.style.width = '794px';
      tempContainer.style.padding = '32px';
      tempContainer.style.background = getBgGradient();
      tempContainer.style.fontFamily = 'Inter, -apple-system, BlinkMacSystemFont, sans-serif';
      document.body.appendChild(tempContainer);

      // Generate paginated content
      const pages = createPaginatedContent();

      // Render each page
      const canvases = [];
      for (let i = 0; i < pages.length; i++) {
        tempContainer.innerHTML = pages[i];

        // Add spacing at bottom to prevent footer overlap
        const spacer = document.createElement('div');
        spacer.style.height = '40px';
        tempContainer.appendChild(spacer);

        const canvas = await window.html2canvas(tempContainer, {
          scale: 2.5,
          useCORS: true,
          allowTaint: false,
          backgroundColor: isDarkMode ? '#0f172a' : '#f8fafc',
          logging: false,
          windowWidth: 794,
          onclone: (clonedDoc) => {
            // Ensure all fonts are loaded
            const style = clonedDoc.createElement('style');
            style.textContent = `
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
            * { font-family: 'Inter', sans-serif !important; }
          `;
            clonedDoc.head.appendChild(style);
          }
        });

        canvases.push(canvas);
      }

      document.body.removeChild(tempContainer);

      // Create PDF
      const pdf = new window.jspdf.jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
        hotfixes: ['px_scaling']
      });

      const margin = 15;
      const pageWidth = 210;
      const contentWidth = pageWidth - margin * 2;
      const provider =null;
      const pageHeight = 297; // A4 height in mm
      const headerMargin = 15;
      const headerFontSize = 10;
      const headerY = 10;     // Y-position for the header text

      // Left: website link
      if (provider?.website) {
        pdf.setFontSize(headerFontSize);
        pdf.setTextColor(isDarkMode ? 200 : 50);
        pdf.text(provider.website, headerMargin, headerY);
      }

      // Right: logo or provider name
      if (provider) {
        if (provider.logo) {
          // Add logo
          const logoSize = 18;
          pdf.addImage(provider.logo, 'PNG', 210 - headerMargin - logoSize, headerY - 5, logoSize, logoSize);
        } else if (provider.name) {
          // Add provider name (split if too long)
          pdf.setFontSize(headerFontSize);
          pdf.setTextColor(isDarkMode ? 200 : 50);
          const maxWidth = 210 - headerMargin * 2;
          const splitName = pdf.splitTextToSize(provider.name, maxWidth);
          splitName.forEach((line, idx) => {
            pdf.text(line, 210 - headerMargin, headerY + idx * (headerFontSize + 2), { align: 'right' });
          });
        }
      }
      for (let i = 0; i < canvases.length; i++) {
        const canvas = canvases[i];
        const scale = contentWidth / canvas.width;
        const pageHeightPx = (297 - margin * 2) / scale;

        if (i > 0) pdf.addPage();
        // Fill full page background
        pdf.setFillColor(isDarkMode ? '#0f172a' : '#f8fafc');
        pdf.rect(0, 0, 210, 297, 'F');

        pdf.addImage(
          canvas.toDataURL('image/png'),
          'PNG',
          margin,
          margin,
          contentWidth,
          canvas.height * scale,
          undefined,
          'FAST'
        );


        // Gradient line
        pdf.setDrawColor(139, 92, 246);
        pdf.setLineWidth(0.5);
        pdf.line(margin, 297 - 22, pageWidth - margin, 297 - 22);

        // Main footer text
        pdf.setFontSize(8);
        pdf.setTextColor(isDarkMode ? '#94a3b8' : '#64748b');
        pdf.setFont('helvetica', 'normal');

        const footerLeft = `${provider?.name || ''}`;
        const footerCenter = `${provider?.address || ''}`;
        const footerRight = `${provider?.website || ''}`;
        const bottom = `Page ${i + 1} of ${canvases.length} · ${new Date().toLocaleDateString()}`;

        const footerY = 297 - 13;
        pdf.text(footerLeft, margin, footerY);
        pdf.text(footerCenter, pageWidth / 2, footerY, { align: 'center' });
        pdf.text(footerRight, pageWidth - margin, footerY, { align: 'right' });

        pdf.setFontSize(7);
        pdf.text(bottom, pageWidth / 2, footerY + 6, { align: 'center' });


      }

      // Save with futuristic filename
      const timestamp = new Date().toISOString().split('T')[0];
      const sanitizedDomain = domain.replace(/[^a-z0-9]/gi, '-').toLowerCase();
      pdf.save(`security-scan-${sanitizedDomain}-${timestamp}.pdf`);

      showToast('Security report generated successfully', 'success');

    } catch (err) {
      console.error('PDF export failed:', err);
      showToast('Failed to generate PDF: ' + err.message, 'error');
    }
    setExporting(false);
  };

  const loadPDFLibraries = async () => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    };

    await loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
    await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
    window.jspdf = window.jspdf || window.jsPDF;
  };

  // Error state
  if (error) {
    return (
      <Container className="py-5">
        <Card className="border-danger border-2 shadow-lg">
          <Card.Body className="text-center py-5">
            <div className="display-1 text-danger mb-4">⚠️</div>
            <h2 className={`fw-bold mb-3 ${isDarkMode ? 'text-light' : 'text-dark'}`}>Unable to Load Scan</h2>
            <p className={` mb-4 ${isDarkMode ? 'text-light' : 'text-dark'}`}>{error}</p>
            <Button 
              variant="outline-primary" 
              onClick={() => window.location.reload()}
              className={`px-4 ${isDarkMode ? 'btn-outline-light' : 'btn-outline-dark'}`}
            >
              Try Again
            </Button>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  

if(state==='result'){
  return renderResults()
}
else if (state==='initial'){ 
   return (
    <>
      <UserInfoModal 
        show={showUserModal}
        onSubmit={handleStartScan}
        loading={scanning}
      />
      
      <ExportModal show={exporting} progress={exportProgress} />
      
      <Container fluid="lg" className="py-4 px-3 px-md-4" style={{minHeight: '100vh'}}>
        {/* Header */}
        <div className="mb-5">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
            <div>
              <h1 className={`fw-bold display-5 mb-2 ${isDarkMode ? 'text-light' : 'text-dark'}`}>
                Security Scan Report
                {config?.name && (
                  <span className=" fs-4 d-block mt-1">{config.name}</span>
                )}
              </h1>
              <p className={` mb-0 ${isDarkMode ? 'text-light' : 'text-dark'}`}>
                Comprehensive vulnerability assessment and security analysis
              </p>
            </div>
            
          </div>

          {/* Scan Info Card */}
          <Card className={`shadow-lg border-0 ${isDarkMode ? 'bg-dark' : 'bg-white'} mb-4`}>
            <Card.Body className="p-4">
              <Row className="align-items-center">
                <Col lg={8}>
                  <Stack gap={3}>
                    <div>
                      <h6 className={`text-uppercase  fw-semibold small mb-2 ${isDarkMode ? 'text-light' : 'text-dark'}`}>Target URL</h6>
                      <h4 className={`fw-bold mb-0 text-break ${isDarkMode ? 'text-light' : 'text-dark'}`}>{config.target}</h4>
                    </div>
                    
                    <Row>
                      <Col md={6}>
                        <h6 className={`text-uppercase  fw-semibold small mb-2 ${isDarkMode ? 'text-light' : 'text-dark'}`}>Scan Configuration</h6>
                        <p className={`fw-medium mb-0 ${isDarkMode ? 'text-light' : 'text-dark'}`}>{config.name || 'Default Scan'}</p>
                      </Col>
                      
                      {/* User info display if available */}
                      {userInfo && (
                        <>
                          <Col md={6}>
                            <h6 className={`text-uppercase  fw-semibold small mb-2 ${isDarkMode ? 'text-light' : 'text-dark'}`}>Scanned By</h6>
                            <p className={`fw-medium mb-0 ${isDarkMode ? 'text-light' : 'text-dark'}`}>{userInfo.name}</p>
                            <small className={` ${isDarkMode ? 'text-light' : 'text-dark'}`}>{userInfo.email}</small>
                          </Col>
                        </>
                      )}
                    </Row>
                    
                    {config.description && (
                      <div>
                        <h6 className={`text-uppercase  fw-semibold small mb-2 ${isDarkMode ? 'text-light' : 'text-dark'}`}>Description</h6>
                        <p className={`mb-0 ${isDarkMode ? 'text-light' : 'text-dark'}`}>{config.description}</p>
                      </div>
                    )}
                  </Stack>
                </Col>
                
                <Col lg={4} className="text-lg-end mt-4 mt-lg-0">
                  {!results && !userInfo && (
                    <Button
                      size="lg"
                      variant="primary"
                      onClick={() => setShowUserModal(true)}
                      className={`px-5 py-3 fw-bold shadow ${isDarkMode ? 'bg-primary text-light' : 'bg-primary text-light'}`}
                    >
                      🚀 Start Security Scan
                    </Button>
                  )}    
                  
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>

        {/* Results Section - PDF Content */}
       {results && renderResults()}
      </Container>
    </>
  );
}
if(state==='loading'){
  return renderSkeletonLoader()
}
};

export default PublicScan;